let language = {
    "LBL_HOME":"Home",
    "LBL_CREATE_EOI":"Create Intent To Submit",
    "LBL_VIEW_EOI":"View Intent To Submit",
    "LBL_EOI_BY":"Intent To Submit By",
    "LBL_NOTE":"Note",
    "LBL_ON_DATE":"Submitted On",
    "LBL_STATUS":"Status",
    "LBL_RELATED_LINKS":"Related Links",
    "LBL_EOI_NO":"Intent To Submit No.",
    "LBL_OPPORTUNITY_TITLE":"Opportunity Title", 
    "LBL_TITLE":"Title",
    "LBL_LINK":"Link",
    "LBL_SAVE":"Save", 
    "LBL_DEADLINE":"Application Deadline",
    "LBL_COMMNET":"Comments",
    "LBL_ACTIVE_STREAM":"Activity Stream",
    "LBL_REMINDER":"Reminder",
    "LBL_REMINDER_TYPE":"Reminder Type",
    "LBL_USER":"User",
    "LBL_DATE":"Date",
    "LBL_TIME":"Time",
    "LBL_ACTION":"Action",
    "LBL_SELECT_DATE":"Select Date",
    "LBL_SET_REMINDER":"Set Reminder",
    "LBL_NOTIFY_USER":"Notify User",
    "LBL_DESCRIPTION":"Description",
    "LBL_SELECT_FILE":"Select File",
    "LBL_ADDED_DOCUMENT":"Added File",
}

export default language;